var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 141,
    viewBox: "0 0 195 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.883 136.959H3.08252V3.09644H191.883V136.959ZM3.42657 136.615H191.539V3.44049H3.42657V136.615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33042 0.192627H0.165039V6.35799H6.33042V0.192627Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50943 6.52319H0V0H6.50943V6.52319ZM0.344049 6.17914H6.16538V0.357804H0.344049V6.17914Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.559 0.192627H94.3936V6.35799H100.559V0.192627Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.738 6.52319H94.2285V0H100.738V6.52319ZM94.5726 6.17914H100.463V0.357804H94.6414L94.5726 6.17914Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.787 0.192627H188.622V6.35799H194.787V0.192627Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.966 6.52319H188.443V0H194.966V6.52319ZM188.787 6.17914H194.622V0.357804H188.787V6.17914Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33042 66.952H0.165039V73.1174H6.33042V66.952Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50943 73.2825H0V66.7731H6.50943V73.2825ZM0.344049 72.9384H6.16538V67.1171H0.344049V72.9384Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.787 66.952H188.622V73.1174H194.787V66.952Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.966 73.2825H188.443V66.7731H194.966V73.2825ZM188.787 72.9384H194.622V67.1171H188.787V72.9384Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33042 133.711H0.165039V139.877H6.33042V133.711Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50943 140.042H0V133.491H6.50943V140.042ZM0.344049 139.698H6.16538V133.877H0.344049V139.698Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.559 133.711H94.3936V139.877H100.559V133.711Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.738 140.042H94.2285V133.491H100.738V140.042ZM94.5726 139.698H100.463V133.877H94.6414L94.5726 139.698Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.787 133.711H188.622V139.877H194.787V133.711Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.966 140.042H188.443V133.491H194.966V140.042ZM188.787 139.698H194.622V133.877H188.787V139.698Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.5908ad6580b444b6a63957b8429ff0be.svg";
export { ForwardRef as ReactComponent };